/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RevokeSessionRequestBody,
  RevokeSessionRequestBody$Outbound,
  RevokeSessionRequestBody$outboundSchema,
} from "../components/revokesessionrequestbody.js";

export type RevokeAgentSessionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RevokeAgentSessionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  revokeSessionRequestBody: RevokeSessionRequestBody;
};

/** @internal */
export type RevokeAgentSessionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeAgentSessionSecurity$outboundSchema: z.ZodMiniType<
  RevokeAgentSessionSecurity$Outbound,
  RevokeAgentSessionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeAgentSessionSecurityToJSON(
  revokeAgentSessionSecurity: RevokeAgentSessionSecurity,
): string {
  return JSON.stringify(
    RevokeAgentSessionSecurity$outboundSchema.parse(revokeAgentSessionSecurity),
  );
}

/** @internal */
export type RevokeAgentSessionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RevokeSessionRequestBody: RevokeSessionRequestBody$Outbound;
};

/** @internal */
export const RevokeAgentSessionRequest$outboundSchema: z.ZodMiniType<
  RevokeAgentSessionRequest$Outbound,
  RevokeAgentSessionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    revokeSessionRequestBody: RevokeSessionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      revokeSessionRequestBody: "RevokeSessionRequestBody",
    });
  }),
);

export function revokeAgentSessionRequestToJSON(
  revokeAgentSessionRequest: RevokeAgentSessionRequest,
): string {
  return JSON.stringify(
    RevokeAgentSessionRequest$outboundSchema.parse(revokeAgentSessionRequest),
  );
}
